// @ai-generated 2026-08-06T09:13:59+00:00 by kai.cissarek@synqony.com using Claude Opus 5
import { EnumContainerActionStatus } from './Generated';

/**
 * A booked action is server-owned from then on: its standing time exists in the container management
 * and outlives the order, so the row must not be changed or removed any more.
 */
export const isBooked = (value: EnumContainerActionStatus) => value === EnumContainerActionStatus.Booked;

/**
 * Whether the action can still be sent into a booking. Only a planned one can: a refused booking
 * rolls back, so the row it could not book is still marked and needs no second marking.
 *
 * Says nothing about whether the user may — that is the permission, checked separately.
 */
export const isOpenForBooking = (value: EnumContainerActionStatus) => value === EnumContainerActionStatus.Planned;
